export const MODULE = {
  USER: "USER",
  TICKET: "TICKET",
};

export const APPROVE_STATUS = {
  // Chưa chuyển phê duyệt
  PENDING: "--",
  // Đang trong quá trình phê duyệt
  IN_PROGRESS: "IN",
  // Từ chối yêu cầu
  REJECTED: "RJ",
  // Phê duyệt đồng ý hoàn toàn
  APPROVED: "FN",
  // Phê duyệt đồng ý một phần
  PARTIALLY_APPROVED: "HF",
  // Thu hồi
  CANCELLED: "BK",
};
